import { w as win } from "./common-namespaces-client-DhfOpdyM.mjs";
const otto = win.otto ?? {};
export {
  otto as o
};
/*🤫*/
